import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from "vue";
import { Tab as HeadlessTab } from "@headlessui/vue";
import Provider from "./Provider.vue";
import { ProvideList } from "../List.vue";

interface TabProps extends ExtractProps<typeof HeadlessTab> {
  fullWidth?: boolean;
}
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  props: {
    fullWidth: { type: Boolean, default: true }
  },
  setup(__props: any) {

const { fullWidth } = __props as { fullWidth: boolean }



const list = inject<ProvideList>("list");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HeadlessTab), { as: "template" }, {
    default: _withCtx(({ selected }) => [
      _createElementVNode("li", {
        class: _normalizeClass([
        'focus-visible:outline-none',
        { 'flex-1': fullWidth },
        { '-mb-px': _unref(list) && _unref(list).variant == 'tabs' },
      ])
      }, [
        _createVNode(Provider, { selected: selected }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", { selected: selected })
          ]),
          _: 2
        }, 1032, ["selected"])
      ], 2)
    ]),
    _: 3
  }))
}
}

})